<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z"
  />
</svg>
